import React from 'react';
import './Vision.css';

const About = () => {
  return (
    <div className="vision-box">
      <h2 className="vision-heading">🎯 Our Vision</h2>
      <p className="vision-text">
        At <strong>Kashmir Jobs</strong>, our vision is to become the most reliable and accessible career platform for the youth of Jammu & Kashmir.
      </p>
      <p className="vision-text">
        We aim to empower every job seeker, from students to experienced professionals, by providing various Job opportunities, learning resources, and community support.
      </p>
      <p className="vision-text">
        Our goal is to bridge the gap between talent and opportunity—enabling growth, self-reliance, and economic progress across the region.
      </p>
    </div>
  );
};

export default About;

